import React from "react";
import apiClient from "../clients/apiClient.js";
import { Box, Divider, FormControl, Input, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import thalamuslogo from './../TopBar/thalamuslogo.svg';


const SelectOrganisation = () => {
    const [organisations, setOrganisations] = React.useState([{
      org_display_name: "Org 1"
    }, {
      org_display_name: "Org 2"
    }, {
      org_display_name: "Org 3"
    }]);
  
    const [filteredOrganisations, setFilteredOrganisations] = React.useState([]);
  
    React.useEffect(() => {
        apiClient.get('/login/select-organisation/').then((response) => {
            const data = response.data;
            console.log('API Response:', data);
  
            // Assuming the response contains an array of organisations
            setOrganisations(data.organisations);
        })
    }, [])
  
    const navigate = useNavigate();
  
    const handleOrganisationSelect = (organisationId) => {
        apiClient.post('/login/select-organisation/', { org_id: organisationId })
            .then((response) => {
                console.log('Organisation selected:', response.data);
                navigate('/'); // Redirect to the home page or another page
                // Handle successful selection, e.g., redirect to another page
            })
            .catch((error) => {
                console.error('Error selecting organisation:', error);
            });
    }
  
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            backgroundColor="#f0f0f0"
        >
            <Box marginTop={"-160px"} marginBottom={"80px"}>
              <img 
                src={thalamuslogo} 
                style={{ 
                  height: ['32px', ' 40px', '48px'], // Responsive height for different breakpoints
                  width: ['410px'],
                }}
              />
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="8px"
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
                minWidth={"480px"}
            >
                <Text fontSize="24px" fontWeight="bold" marginBottom="20px">
                    Select Organisation
                </Text>
                <Divider />
                <FormControl>
                  <Input
                    type="text"
                    autoComplete="off"
                    placeholder="Search your organisation"
                    onChange={(e) => {
                      const query = e.target.value.toLowerCase();
                      if (query === "" || query.length < 3) {
                        setFilteredOrganisations([]);
                        return;
                      }
                      setFilteredOrganisations(organisations.filter((org) => org.org_display_name.toLowerCase().includes(query)));
                      }}
                    />
                    </FormControl>
                    <Box marginTop="20px">
                      {filteredOrganisations?.map((organisation, index) => (
                        <Box
                          key={index}
                          padding="15px"
                          marginBottom="15px"
                          backgroundColor="#f0f8ff"
                          borderRadius="8px"
                          boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
                          width="320px"
                          textAlign="center"
                          cursor="pointer"
                          transition="all 0.3s ease"
                          _hover={{
                          backgroundColor: "#e6f7ff",
                          transform: "scale(1.02)",
                          boxShadow: "0 6px 10px rgba(0, 0, 0, 0.15)",
                          }}
                          _active={{
                          backgroundColor: "#d9f0ff",
                          transform: "scale(0.98)",
                          }}
                          onClick={() => handleOrganisationSelect(organisation.org_id)}
                        >
                          <Text fontSize="18px" fontWeight="bold" color="#333">
                            {organisation.org_display_name}
                          </Text>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
  }

export default SelectOrganisation;